import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import Carousal from "../../components/layouts/carousal";

import Navbar from "../../components/layouts/navbar";
import {useNavigate} from "react-router-dom"


function Index() {

  const navigate  = useNavigate();

  let login =()=>{
    navigate("/login")
  }
    return (
        <>
            {/* <Typography variant="h1">Index Screen</Typography> */}
            <Box >
            <Box  >
                <Box>

                    <Navbar />
                </Box>

            <Box >
                <Carousal/>
            </Box>

            <Box>
                <Box sx={{marginTop:"30px", color:"grey"}}>
                    <Typography variant="h5">WELCOME TO HOTEL MANAGEMENT APP</Typography>
                </Box>
                <Box sx={{marginTop:"10px"}}>
                    <Typography variant="h3">World's most secure hotel, an oasis in the city</Typography>
                </Box>
                <Box >
                    <div class="album py-5 bg-dark" >
    <div class="container">

      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
        <div class="col">
          <div class="card shadow-sm">
            <img width="100%" src="https://images.unsplash.com/photo-1455587734955-081b22074882?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" />
            <div class="card-body">
              <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <button type="button" onClick={login} class="btn btn-sm btn-outline-secondary">Booking</button>
                  <button type="button" class="btn btn-sm btn-outline-secondary">Detail</button>
                </div>
                <small class="text-muted">9 mins</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src="https://images.unsplash.com/photo-1618773928121-c32242e63f39?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" alt="hotel Pic" />
            <div class="card-body">
              <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <button type="button" onClick={login}  class="btn btn-sm btn-outline-secondary">Booking</button>
                  <button type="button"  class="btn btn-sm btn-outline-secondary">Detail</button>
                </div>
                <small class="text-muted">9 mins</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img  src="https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" alt="hotel Pic" />
            <div class="card-body">
              <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <button type="button" onClick={login} class="btn btn-sm btn-outline-secondary">Booking</button>
                  <button type="button" class="btn btn-sm btn-outline-secondary">Detail</button>
                </div>
                <small class="text-muted">9 mins</small>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="card shadow-sm">
            <img src="https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" alt="hotel Pic" />
            <div class="card-body">
              <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <button type="button" onClick={login} class="btn btn-sm btn-outline-secondary">Booking</button>
                  <button type="button" class="btn btn-sm btn-outline-secondary">Detail</button>
                </div>
                <small class="text-muted">9 mins</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src="https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"  alt="hotel Pic"/>
            <div class="card-body">
              <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <button type="button" onClick={login} class="btn btn-sm btn-outline-secondary">Booking</button>
                  <button type="button" class="btn btn-sm btn-outline-secondary">Detail</button>
                </div>
                <small class="text-muted">9 mins</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src="https://images.unsplash.com/photo-1596394516093-501ba68a0ba6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" alt="hotel Pic" />
            <div class="card-body">
              <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <button type="button" onClick={login} class="btn btn-sm btn-outline-secondary">Booking</button>
                  <button type="button" class="btn btn-sm btn-outline-secondary">Detail</button>
                </div>
                <small class="text-muted">9 mins</small>
              </div>
            </div>
          </div>
        </div>     
      </div>
    </div>
  </div>
                </Box>
            </Box>
                
            </Box>

            </Box>

        </>
    )
}

export default Index;